import { render, staticRenderFns } from "./TablePaging.vue?vue&type=template&id=1227e3cc&"
import script from "./TablePaging.vue?vue&type=script&lang=js&"
export * from "./TablePaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports